const partnerVideoKeys = {
  century21: "QFnMu_bRoko",
  coldwellbanker: "jzusPbIbPPI"
};

export default partnerVideoKeys;
